import { useEffect, useRef, useState } from "react";

// highlight the pinned group when user adds an item
const useMainNavigationPinnedHighlight = (pinnedItemsCount: number): boolean => {
  const [isHighlighted, setIsHighlighted] = useState(false);
  const prevCountRef = useRef(pinnedItemsCount);

  useEffect(() => {
    const prevCount = prevCountRef.current;
    const currentCount = pinnedItemsCount;

    prevCountRef.current = currentCount;

    if (currentCount > prevCount) {
      const startTimer = setTimeout(() => {
        setIsHighlighted(true);

        const endTimer = setTimeout(() => {
          setIsHighlighted(false);
        }, 900);

        return () => clearTimeout(endTimer);
      }, 0);

      return () => clearTimeout(startTimer);
    }

    return undefined;
  }, [pinnedItemsCount]);

  return isHighlighted;
};

export default useMainNavigationPinnedHighlight;
